'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetchVacancyData ({id}) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/spec-private/citibank/vacancies/${id}`)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  updateVacancyData ({id}, data) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/spec-private/citibank/vacancies/${id}`, data)
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  }
}
